// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessMainDiv {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  margin-left: 20px;
  margin-right: 20px;
  margin-bottom: 20px;
  height: 336px;
  flex-shrink: 0;
  width: 100%;
}

.accessInnerDiv {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.accessImg {
  margin-top: 36px;
  width: 120px;
  height: 120px;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/accessDenied/accessDenied.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".accessMainDiv {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  margin-left: 20px;\n  margin-right: 20px;\n  margin-bottom: 20px;\n  height: 336px;\n  flex-shrink: 0;\n  width: 100%;\n}\n\n.accessInnerDiv {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.accessImg {\n  margin-top: 36px;\n  width: 120px;\n  height: 120px;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
